import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as partnerCategoriesActions from '../../../actions/partner-categories';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';
import LocalizedStrings from '../../../localization/strings';
import PartnerCategoryForm from '../../../components/partner-category/partner-category-form';

class PartnerCategoryContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/partner-categories';
    }

    fetchItem(id) {
        return this.props.actions.fetchPartnerCategory(id);
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">{LocalizedStrings.partnerCategoryEdit}</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <PartnerCategoryForm submit={actions.submitPartnerCategory}
                                               onSuccessSubmit={this.onSuccessSubmit.bind(this)}/>
                    }
                </div>
            </div>
        )

    }
}

export default connect(function (state) {
    return {loading: state.admin.partnerCategories.loading};
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...partnerCategoriesActions
        }, dispatch)
    };
})(PartnerCategoryContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/partner-category/partner-category-container.js